import { Injectable } from "@angular/core";
import { PublicHttpClientService } from "./http-client.service";
import { Observable } from "rxjs";
import { tap } from "rxjs/operators";

@Injectable()
export class PublicReferencesService {
  constructor(private http: PublicHttpClientService) {}

  public getReferences(application_id): Observable<any> {
    return this.http
      .get("/api/public/applications/" + application_id + "/references")
      .pipe(tap((_) => console.log("PublicApplicationsService.getReferences: Ok")));
  }

  public create(reference): Observable<any> {
    const params = {
      reference: reference,
      phone: reference.phone.info,
    };
    return this.http
      .post("/api/public/references/create_one_reference", params)
      .pipe(tap((_) => console.log("PublicReferencesService.create: Ok.")));
  }

  public update(reference): Observable<any> {
    const params = {
      reference: reference,
      phone_info: reference?.phone?.info,
      phone_id: reference?.phone?.id,
    };
    return this.http
      .put("/api/public/references/" + reference.id + "/update_reference", params)
      .pipe(tap((_) => console.log("ReferencesService.update: Ok.")));
  }

  public delete(reference_id): Observable<any> {
    return this.http
      .delete("/api/public/references/" + reference_id + "/delete")
      .pipe(tap((_) => console.log("ReferencesService.delete: Ok.")));
  }
}
